export default __webpack_public_path__ + "static/media/Badge_bronze.804b64f4.svg";